const convertVideoLink = (link) => {
    let youtubeEmbedLink = "https://www.youtube.com/embed/{id}";
    let vimeoEmbedLink = "https://player.vimeo.com/video/{id}";
    if (link === "") return null;
    try {
        let youtubeLink = link.indexOf("you") !== -1;
        let id = "";
        if (link.indexOf("wirewax") !== -1) return link;
        if (youtubeLink) {
            if (link.indexOf("https://www.youtube.com/watch") !== -1) {
                let split = link.split(RegExp("v=([a-zA-Z0-9]+)?"));
                id = split[1];
            } else if (link.indexOf("youtu.be") !== -1) {
                let split = link.split(".be/");
                id = split[1];
            } else if (link.indexOf("embed") !== -1) {
                let split = link.split("embed/");
                id = split[1];
            }
            return youtubeEmbedLink.replace("{id}", id);
        } else {
            if (link.indexOf("player") !== -1) {
                let split = link.split(RegExp("video/([a-zA-Z0-9]+)?"));
                id = split[1];
            } else {
                let split = link.split(".com/");
                id = split[1];
            }
            return vimeoEmbedLink.replace("{id}", id);
        }
    } catch {
        return link;
    }
};

export default convertVideoLink;
